import { Chip } from "@material-ui/core";
import Translator from "Languages/Utility/Translator";
import React, { Fragment } from "react";
import * as Icons from 'react-bootstrap-icons';

export default function StatusFormatterIcons(cell, row = null, deactive = false) {
  return (
    (row && row.IsActive )
    ? <div className="StatusIconsWarning StatusIconsDeactivate">
      <Icons.DashSquare size={20} />
    </div>
    : <div className={cell ? `StatusIconsEnable ${deactive && 'StatusIconsDeactivate'}` : `StatusIconsDisable ${deactive && 'StatusIconsDeactivate'}`}>
      {
        cell ? <Icons.CheckSquare size={20} /> : <Icons.XSquare size={20} />
      }
    </div>
  );
}
